<template>
  <div class="ts-overflow-scroll ts-max-h-screen">
    <div class="form-group" style="width: 250px;">
      <label
        style="display: inline-block; margin-right: 8px; white-space: nowrap;"
      >
        {{ $t('class-attendance-report-for-admin.session') }}
      </label>
      <a-select
        v-model="session_id"
        :options="sessionOptions"
        :placeholder="$t('all')"
        style="width: 150px"
        showSearch
        mode="multiple"
        :filterOption="
          (input, option) =>
            option.componentOptions.children[0].text
              .toLowerCase()
              .indexOf(input.toLowerCase()) >= 0
        "
        :maxTagCount="1"
      ></a-select>
    </div>
    <ts-table :columns="columns" :records="studentList">
      <template v-slot="{ record, index }">
        <td style="vertical-align: middle;">
          {{ index + 1 }}
        </td>
        <td style="vertical-align: middle;">{{ record.card_number }}</td>
        <td>
          <img
            class="ts-w-10 ts-rounded-sm ts-shadow-md"
            v-lazy="{
              src: photo(record),
              error: onError(),
              loading: require('@/assets/Rolling-1s-200px_2.svg')
            }"
          />
        </td>
        <td style="vertical-align: middle;">
          <b class="ts-text-blue-600">{{ record.full_name_en }}</b>
        </td>
        <td style="vertical-align: middle;">
          {{ record.gender }}
        </td>
        <td style="vertical-align: middle;">
          {{ record.date_of_birth }}
        </td>
        <td style="vertical-align: middle;">
          {{ record.phone }}
        </td>
      </template>
    </ts-table>
  </div>
</template>
<script>
import { includes } from 'lodash'
import { mapActions } from 'vuex'
export default {
  name: 'viewStudentList',
  props: ['student'],
  data() {
    return {
      photoError: require('../../../assets/user_default.png'),
      sessionOptions: [],
      session_id: []
    }
  },
  created() {
    this.getSessionFilter()
  },
  computed: {
    studentList() {
      if (this.session_id.length === 0) return this.student;

      return this.student.filter(el => {
        // Convert split values to numbers
        const sessions = el.session_id.split(',').map(s => Number(s));
        // Check if any selected id matches
        return sessions.some(s => this.session_id.includes(s));
      });
    },
    columns() {
      return [
        {
          name: this.$t('school.academic.operation.classOperation.no')
        },
        {
          name: this.$t('school.academic.operation.classOperation.studentId'),
          sortKey: 'card_number'
        },
        {
          name: this.$t('school.academic.operation.classOperation.photo'),
          style: 'text-align:center'
        },
        {
          name: this.$t('school.academic.operation.classOperation.studentName'),
          sortKey: 'full_name_en'
        },
        {
          name: this.$t('school.academic.operation.classOperation.sex')
        },
        {
          name: this.$t('school.academic.operation.classOperation.dob')
        },
        {
          name: this.$t('school.academic.operation.classOperation.phone')
        }
      ]
    }
  },
  methods: {
    ...mapActions('classOperation', ['formViewModel']),
    photo(record) {
      if (record.photo) {
        return record.photo
      }

      return this.photoError
    },
    onError() {
      event ? (event.target.src = this.photoError) : ''
    },
    async getSessionFilter() {
      return this.formViewModel({
        fnName: 'getSession'
      }).then(response => {
        if (response) {
          this.sessionOptions = response.data.getSession.map(item => {
            return {
              value: item.session_id,
              label: item.session_name
            }
          })
        } else {
          this.$message.error(response.data.message)
        }
      })
    }
  },
  watch: {
  student: {
    handler() {
      this.session_id = []
    },
    immediate: true
  }
}
}
</script>

<style lang="css" scoped>
table {
  width: 100%;
  border-collapse: collapse;
}
table thead tr th {
  text-transform: uppercase;
  padding: 4px 7px;
  background: rgb(218, 218, 218);
}
table tbody tr td {
  padding: 4px 7px;
}
</style>
